import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Error from "../../Common/Error";
import LoadingButton from "../../Common/LoadingButton";
import { TDialog, TDialogTitle, TDialogContent, TDialogActions } from "../../Common/TDialog";

export const ForgotPasswordEntryDialog = (props) => {
    const checkValidity = () => {
        return props.email && props.email.includes("@");
    };

    const handleEmailChange = (e) => {
        props.setEmail(e.target.value);
    };

    const handleBackClick = () => {
        props.onCancel();
    };

    const handleSendClick = () => {
        props.onSave?.(props.email);
    };

    return (
        <TDialog open={props.open}>
            <TDialogTitle>Forgot my password</TDialogTitle>

            <TDialogContent>
                <Typography style={{ color: "#0000008a" }}>
                    Having trouble logging in to your account? Please provide your email and we will send you
                    instructions on how to change your password.
                </Typography>

                {props.message && <Typography variant="body1">{props.message}</Typography>}

                {props.error && <Error message={props.error} />}

                <TextField
                    type="email"
                    label="Email"
                    value={props.email ?? ""}
                    required
                    fullWidth
                    onChange={handleEmailChange}
                    style={{ marginTop: "20px" }}
                />
            </TDialogContent>

            <TDialogActions>
                <Button color="secondary" disabled={props.saving} onClick={handleBackClick}>
                    Back
                </Button>

                <LoadingButton
                    color="primary"
                    disabled={!checkValidity()}
                    loading={props.saving}
                    onClick={handleSendClick}
                >
                    Send reset instructions
                </LoadingButton>
            </TDialogActions>
        </TDialog>
    );
};

ForgotPasswordEntryDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    email: PropTypes.string,
    setEmail: PropTypes.func,
    message: PropTypes.string,
    saving: PropTypes.bool,
    error: PropTypes.string,
    onSave: PropTypes.func,
    onCancel: PropTypes.func,
};

ForgotPasswordEntryDialog.defaultProps = {
    saving: false,
};

export default ForgotPasswordEntryDialog;
